import Filtro from "./Filtro";

export { default as actions } from "./actions";
export { default as reducer } from "./reducer";

export default Filtro;
